export default "__VITE_ASSET__Deyt4Co2__"